'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { analyticsEvents } from 'plp/services/analyticsEvents'
import { getCatalogProductCardSettings } from 'plp/utils/catalogProductCardSettings'
import { ProductList } from 'product-list/components/ProductList/ProductList'
import { ProductListAnalyticsProvider } from 'product-list/context/ProductListAnalyticsProvider/ProductListAnalyticsProvider'
import type { UseFiltersData } from 'product-list/types/Filters'
import type {
	ProductListGroup,
	ProductListParams,
	RenderedProductListItem,
} from 'product-list/types/ProductsList'
import type { Product } from 'product/types'
import type { Channel } from 'types/masterData'

import { catalogConfig } from '../../../constants/catalogConfig'
import { usePlpProductListProvider } from '../../../context/PlpProductListProvider/usePlpProductListProvider'

/* eslint react-hooks/exhaustive-deps: warn */

export function List({
	catalogItemsData,
	channel,
	country,
	filtersData,
	groupsWithFilteredProducts,
	hasServerFilters,
	listName,
	processedFilters,
	rootCatalogPathname,
	serverProducts,
}: {
	catalogItemsData: Product[]
	channel: Channel
	country: string
	filtersData: UseFiltersData | null
	groupsWithFilteredProducts: ProductListGroup[]
	hasServerFilters: boolean
	listName: string
	processedFilters: ProductListParams | undefined
	rootCatalogPathname: string
	serverProducts: RenderedProductListItem[]
}) {
	const {
		country: { hasOnlineSale },
	} = useMasterData()

	const catalogProductCardSettings = getCatalogProductCardSettings({
		hasOnlineSale,
	})
	const { defaultView, setCurrentView } = usePlpProductListProvider()

	return (
		<ProductListAnalyticsProvider
			hasServerFilters={hasServerFilters}
			events={{
				onViewChange: analyticsEvents.sendLayoutViewChange,
				onFiltersWasApplied: analyticsEvents.sendApplyFiltersEvent,
				onFiltersWasClosed: analyticsEvents.sendCloseFiltersEvent,
				onFiltersWasOpened: analyticsEvents.sendOpenFiltersEvent,
				onListEndWasReached: analyticsEvents.sendPlpEndEvent,
				onZeroResults: analyticsEvents.sendNoResultFiltersEvent,
			}}
		>
			<ProductList
				config={catalogConfig}
				defaultFilter={processedFilters}
				responsiveProductCardSettings={catalogProductCardSettings}
				defaultView={defaultView}
				displayFilters={true}
				displayViewSelector={true}
				filterResultPathname={rootCatalogPathname}
				filtersData={filtersData}
				filtersOnClientEndpoint={`/ws-product-lists/v1/channels/${channel}/countries/${country}/catalogs/${listName}/filters`}
				groups={groupsWithFilteredProducts}
				hasServerFilters={hasServerFilters}
				name={listName}
				preLoadedProductsData={catalogItemsData}
				serverProducts={serverProducts}
				onUserViewChange={setCurrentView}
			/>
		</ProductListAnalyticsProvider>
	)
}
